export type RegraQualidade = {
  rotulo: string;
  descricao: string;
};

export const REGRAS_QUALIDADE = {
  renegociacao: {
    rotulo: 'Renegociação',
    descricao: 'Cada número de renegociação existe inteiro numa linha do P2B.',
  },
  administrador: {
    rotulo: 'Administrador',
    descricao: 'O telefone do administrador está numa linha do P2B, no Contato 1 ou 2 da fatura ou no Lemmit. Sem telefone no contrato, a conferência fica em aberto.',
  },
  linhasASuspender: {
    rotulo: 'Linhas a suspender',
    descricao: 'O número marcado para suspender existe no P2B.',
  },
  periodoLinhasASuspender: {
    rotulo: 'Período linhas a suspender',
    descricao: 'Só pode suspender linha com 4 meses ou menos de fidelidade (Parcelas Restantes do relatório Phoenix). Sem um número único no relatório, o campo sai como 0. Zero permite a suspensão.',
  },
  renovaTodasAsAtivas: {
    rotulo: 'Renova todas as ativas',
    descricao: 'Toda linha verde do P2B está na renegociação ou numa suspensão justificada.',
  },
  ativasAcessos: {
    rotulo: 'Ativas × acessos',
    descricao: 'A quantidade de linhas verdes é igual ao total de acessos. Amarelo e vermelho contam como não ativas, mesmo com suspensão justificada.',
  },
  linhaSuspensa: {
    rotulo: 'Linha suspensa',
    descricao: 'A linha está suspensa na estrutura e o contrato não pediu a suspensão.',
  },
  inadimplencia: {
    rotulo: 'Inadimplência',
    descricao: 'Com suspensão no contrato, diverge. Sem suspensão, só com renegociação, segue.',
  },
  pedidoNoGettel: {
    rotulo: 'Pedido no Gettel',
    descricao: 'O pedido do VTME existe no Gettel.',
  },
  numeros: {
    rotulo: 'Números',
    descricao: 'Cada acesso do VTME, exceto linha nova, casa com um número do Gettel. Linha que existe só no Gettel não reprova.',
  },
  ddd: {
    rotulo: 'DDD',
    descricao: 'O mesmo assinante está com DDD diferente entre o VTME e o Gettel.',
  },
} as const satisfies Record<string, RegraQualidade>;

export const REGRAS_VTME = {
  negociacao: {
    rotulo: 'Negociação',
    descricao: 'Gettel Aditivo ou Cliente novo deve ser VTME Aditivo. Gettel Renegociação deve ter no VTME um tipo que começa com Reneg. Se Aditivo e Renegociação apontam para o mesmo pedido, diverge.',
  },
  cnpj: {
    rotulo: 'CNPJ',
    descricao: 'O CNPJ do contrato Gettel (ClientCnpj) deve ser o mesmo de stDocIdentCliente da Busca ou do CNPJ do pedido VTME.',
  },
  administrador: {
    rotulo: 'Administrador',
    descricao: 'O Responsável pela Auditoria do Gettel (nome, CPF, telefone e e-mail) deve ser o Administrador do contrato no VTME. Casa por CPF; se faltar, por telefone.',
  },
  representantes: {
    rotulo: 'Representantes',
    descricao: 'Nome, CPF e telefone de cada representante legal devem ser iguais no Gettel e no VTME. Casa por CPF; se faltar, por telefone.',
  },
  autorizados: {
    rotulo: 'Autorizados a receber',
    descricao: 'Gettel Recebedores Autorizados × VTME Autorizados a Receber: nome, CPF e telefone. Casa por CPF; se faltar, por telefone.',
  },
  linhas: {
    rotulo: 'Linhas',
    descricao: 'No grupo, a união das linhas dos contratos. No Aditivo ou Cliente novo, ICCID (ChipCcid × observações do pedido VTME), sem exigir DDD+número. Na Renegociação, DDD+número. Plano (Plan.Name × oferta VTME, ignorando sufixo de valor) e valor (ValorTotalMensal, ou catálogo do plano se o snapshot estiver zerado, × dbFranquia).',
  },
} as const satisfies Record<string, RegraQualidade>;

const POR_ROTULO = new Map<string, string>([
  ...Object.values(REGRAS_VTME).map((regra) => [regra.rotulo, regra.descricao] as const),
  ...Object.values(REGRAS_QUALIDADE).map((regra) => [regra.rotulo, regra.descricao] as const),
]);

export function descricaoDaRegra(rotulo: string): string {
  return POR_ROTULO.get(rotulo) ?? '';
}
